module.exports = __webpack_public_path__ + "media/images/fav-icon-3cc2379421f9b00e5f75c90887a71cf7.jpg";